import { render } from "./CargueFormato.vue?vue&type=template&id=a68a6636"
import script from "./CargueFormato.vue?vue&type=script&lang=js"
export * from "./CargueFormato.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__